import { ref } from 'vue';

// Export notifications render bottom-right via <ExportToastHost>, deliberately
// OUTSIDE the global top-right Nuxt UI toaster: the Export popover opens
// top-right, so a top-right toast would sit on top of it. Every other toast
// keeps the shared top-right behavior — only this one lives at the bottom.
const exportToasts = ref([]);
let _seq = 0;

function _add(data) {
  const id = `export-toast-${++_seq}`;
  exportToasts.value.push({ id, ...data });
  return id;
}

export const useExportNotifications = () => {
  const showExportSuccessToast = (p_fileName, p_downloadUrl) =>
    _add({
      type: 'success',
      success: true,
      fileName: p_fileName,
      downloadUrl: p_downloadUrl,
    });

  const showExportErrorToast = p_fileName =>
    _add({
      type: 'error',
      success: false,
      fileName: p_fileName,
    });

  const dismissExportToast = id => {
    exportToasts.value = exportToasts.value.filter(t => t.id !== id);
  };

  return {
    exportToasts,
    showExportSuccessToast,
    showExportErrorToast,
    dismissExportToast,
  };
};
